import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import translations from '../../i18n';
import { LanguageContext } from '../LanguageContext';

const STORAGE_KEY = 'tfai:language';
const DEFAULT_LANGUAGE = 'en';

const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(DEFAULT_LANGUAGE);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored && translations[stored]) {
        setLanguageState(stored);
      }
    } catch (e) {}
  }, []);

  const setLanguage = useCallback(lang => {
    if (!translations[lang]) return;
    setLanguageState(lang);
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {}
  }, []);

  const t = useCallback((key, fallbackValue) => {
    const path = Array.isArray(key) ? key : String(key).split('.');
    const traverse = (obj, parts) => parts.reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
    const translation = traverse(translations[language] || {}, path);
    const defaultTranslation = traverse(translations[DEFAULT_LANGUAGE] || {}, path);
    if (translation !== undefined) return translation;
    if (defaultTranslation !== undefined) return defaultTranslation;
    return fallbackValue !== undefined ? fallbackValue : path.join('.');
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    t
  }), [language, setLanguage, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.any
};

export { LanguageProvider, DEFAULT_LANGUAGE };
